export const LOCAL_STORAGE_USER_AUTHENTICATED = "userAuthenticated";
export const LOCAL_STORAGE_USER_VERIFIED = "userVerified";
export const LOCAL_STORAGE_USER_ALL_ROLES = "userAllRoles";
export const LOCAL_STORAGE_USER_SELECTED_ROLE = "userSelectedRole";